<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-container>
      <h2 class="title">Customer Details</h2>
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-text-field
            v-model="customer.fullname"
            :rules="[rules.required]"
            label="Full Name *"
            required
            outlined
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
          <v-text-field
            v-model="customer.email"
            :rules="[rules.required, rules.email]"
            label="Email *"
            required
            type="email"
            outlined
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
          <v-text-field
            v-model="customer.phone"
            :rules="[rules.required]"
            label="Phone *"
            required
            type="tel"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-text-field
            v-model="customer.street"
            label="Street *"
            :rules="[rules.required]"
            required
            outlined
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
        
          <v-text-field
            v-model="customer.city"
            :rules="[rules.required]"
            label="City *"
            required
            outlined
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
          <v-text-field
            v-model="customer.zipcode"
            :rules="[rules.required]"
            label="Zipcode *"
            required
            type="tel"
            outlined
          ></v-text-field>
        </v-col>
      </v-row> -->
      <h2 class="title">Customer Address</h2>
      <div v-for="(address, i) in addresses" :key="`address-${i}`">
        <CustomerAddress :address=address :rules=rules :remove=removeAddress :i=i />
      </div>
      <div class="mb-5">
        <v-btn
          color="primary"
          class="mr-4"
          @click="addAddress"
        >
          Add Address
        </v-btn>
      </div>
      <h2 class="title">Cars Details</h2>
      <div v-for="(car, i) in cars" :key="`car-${i}`">
        <CustomerCar :car=car :rules=rules :remove=removeCar :i=i />
      </div>
      <div class="mb-5">
        <v-btn
          color="primary"
          class="mr-4"
          @click="addCar"
        >
          Add Car
        </v-btn>
      </div>

      <v-btn
        color="success"
        class="mr-4"
        @click="submit"
      >
        Save
      </v-btn>
      <v-btn
        color="error"
        class="mr-4"
        @click="reset"
      >
        Reset
      </v-btn>
    </v-container>

  </v-form>
</template>

<script>
import CustomerCar from "./CustomerCar";
import CustomerAddress from "./CustomerAddress";

import api from "@/api";
const car = {
  make: '',
  model: '',
  year: '',
  vin: '',
}
const address = {
  street: '',
  city: '',
  zipcode: '',
}
export default {
  name: "AddCell",
  components: {
    CustomerCar,
    CustomerAddress
  },
  data: () => ({
    valid: false,
    customer: {
      fullname: '',
      email: '',
      phone: '',
      street: '',
      city: '',
      zipcode: '',
    },
    cars: [{
      ...car
    }],
    addresses: [{
      ...address
    }],
    rules: {
      required: v => !!v || 'Name is required',
      email: v => /.+@.+/.test(v) || 'E-mail must be valid',
      max: (len) => v => v.length <= len || `Must be less than ${len} characters`,
    }
  }),
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        if(this.$route.params.id) {
          this.update();
        } else {
          this.save();
        }
      }
    },
    async save () {
      if (this.$refs.form.validate()) {
        try {
          const addresses = this.addresses.map(address => ({
            ...address,
            city: (address?.city || "").trim(),
            zipcode: (address?.zipcode || "").trim()
          }));
          const payload = {
            ...this.customer,
            cars: this.cars,
            addresses
          }
          await api.addCustomer(payload);
          this.$toast.success("Customer Added Successfully");
          this.reset();
        } catch (error) {
          this.$toast.error("Error Adding Customer");
        }
      }
    },
    async update() {
      try {
        const payload = {
          ...this.customer,
          cars: this.cars,
          addresses: this.addresses
        }
        await api.updateCustomer(this.$route.params.id, payload);
        this.$toast.success("Customer Updated Successfully");
        this.$router.push("/customers")
      } catch (error) {
        this.$toast.error("Error Updating Customer");
      }
    },
    reset () {
      this.$refs.form.reset();
    },
    async getCustomer(id) {
      try {
        const { data } = await api.getCustomer(id);
        this.customer = data.customer;
        this.cars = data.cars;
        this.addresses = data.addresses;
      } catch (error) {
        this.$toast.error("Error Finding Customer");
      }
    },
    addCar() {
      this.cars.push({...car})
    },
    removeCar(i) {
      this.cars.splice(i, 1)
    },
    addAddress() {
      this.addresses.push({...address})
    },
    removeAddress(i) {
      this.addresses.splice(i, 1)
    }
  },
  mounted() {
    if(this.$route.params && this.$route.params.id) {
      this.getCustomer(this.$route.params.id);
    }
  }
};
</script>